<section class="page">
  <h1>Historique des achats</h1>
  <spw-message
    *ngIf="errorMessage"
    [messageTitle]="'Erreur'"
    variant="alert"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ errorMessage }}
  </spw-message>

  <spw-message
    *ngIf="successMessage"
    [messageTitle]="'Succès'"
    variant="success"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ successMessage }}
  </spw-message>

  <div class="loading" *ngIf="isLoading">
    <spw-loading></spw-loading>
  </div>

  <div *ngIf="!isLoading" class="history">
    <spw-table>
      <spw-table-head>
        <spw-table-row>
          <spw-table-header>Date</spw-table-header>
          <spw-table-header>Acheteur</spw-table-header>
          <spw-table-header *ngIf="authService.isAdmin()">Actions</spw-table-header>
        </spw-table-row>
      </spw-table-head>
      <spw-table-body>
        <spw-table-row *ngFor="let item of purchases">
          <spw-table-cell>{{ item.purchasedAt | date: 'dd/MM/yyyy HH:mm' }}</spw-table-cell>
          <spw-table-cell>{{ item.buyer.prenom }} {{ item.buyer.nom }}</spw-table-cell>
          <spw-table-cell *ngIf="authService.isAdmin()">
            <spw-button
              variant="secondary"
              size="small"
              [disabled]="deletingId === item.id"
              (click)="cancelPurchase(item)"
            >
              {{ deletingId === item.id ? 'Annulation...' : 'Annuler' }}
            </spw-button>
          </spw-table-cell>
        </spw-table-row>
      </spw-table-body>
    </spw-table>

    <div class="history__actions" *ngIf="hasMore">
      <spw-button variant="secondary" [disabled]="isLoadingMore" (click)="loadHistory(false)">
        {{ isLoadingMore ? 'Chargement...' : 'Charger plus' }}
      </spw-button>
    </div>
  </div>
</section>
